import { Button, Checkbox } from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRightIcon, NoDataIcon } from "../../Assets/images/svgs";
import { Title, WidgetLegend } from "../../Components/Atoms"; 
import { Bar } from "../../Components/Organisms/Graphs";
import { Ratio } from "../../Components/Organisms/Graphs";
import PATHS from "../../Routes/paths";
import { MODULE_TYPES, STATS_ENUMS } from "../../Library/widgets";

const BatteryVoltage = ({ data, enums }) => {
  const navigate = useNavigate();
  const processedData = useMemo(() => {
    const processed = [];

    (data || []).forEach((d) => {
      const alarm = enums[d.idx];
      processed.push({ alarm: alarm.label, count: d.count, color: alarm.color });
    })

    return processed;
  }, [ data, enums ]);

  const parser = { x: "alarm", y: "count" };

  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>Battery Voltage</Title>
      </header>

      <main className="widget-section">
        {data ? (
          <>
            <div className="widget-ratio-chart">
              <Ratio data={processedData} parser={parser} title="Battery Voltage" />
            </div>

            <div className="widget-legend widget-legend-10 widget-legend-full">
              <WidgetLegend data={processedData} parser={parser} />
            </div>

            <div className="widget-link">
              <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.BATTERY_VOLTAGE)}>
                View Reports
              </Button>
            </div>
          </>
        ) : (
          <div className="widget-image">
            <NoDataIcon />
          </div>
        )}
      </main>
    </article>
  );
};

const BatteryTemperature = ({ data, enums }) => {
  const navigate = useNavigate();
  const [ checked, setChecked ] = useState(true);
  const handleChange = (e) => setChecked(e.target.checked);

  const processedData = useMemo(() => {
    // Filling Alarm Names in Data
    const processed = { charging: [], discharging: [] };

    if (data.charging && data.discharging) {
      (data ? data.charging : []).forEach((d) => {
        const alarm = enums[d.idx];
        processed.charging.push({ alarm: alarm.label, count: d.count, color: alarm.color });
      });

      (data ? data.discharging : []).forEach((d) => {
        const alarm = enums[d.idx];
        processed.discharging.push({ alarm: alarm.label, count: d.count, color: alarm.color });
      });
    } else {
      data.forEach((d) => {
        const alarm = enums[d.idx];
        processed.charging.push({ alarm: alarm.label, count: d.count, color: alarm.color });
      });
    }

    return processed;
  }, [ data, enums ]);

  const parser = { x: "alarm", y: "count" };

  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>Battery Temperature</Title>
      </header>

      <main className="widget-section">
        {data ? (
          <>
            <div className="widget-ratio-chart">
              <Ratio data={checked ? processedData.charging : processedData.discharging} parser={parser} title="Battery Temperature" />
            </div>
            {processedData.discharging.length ? (
              <Checkbox className="widget-checkbox" isChecked={checked} onChange={handleChange}>
                While Charging
              </Checkbox>
            ) : null}

            <div className="widget-legend widget-legend-10 widget-legend-full">
              <WidgetLegend data={checked ? processedData.charging : processedData.discharging} parser={parser} />
            </div>

            <div className="widget-link">
              {/*
                <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.BATTERY_TEMPERATURE)}>
                  View Reports
                </Button>
              */}
            </div>
          </>
        ) : (
          <div className="widget-image">
            <NoDataIcon />
          </div>
        )}
      </main>
    </article>
  );
};

const ShowPercentageGraph = ({ title, path, xLabel, yLabel, data, enums }) => {
  const navigate = useNavigate();
  const parser = { x: "label", y: "count", xLabel, yLabel };

  const graphData = useMemo(() => {
    return data.map((d) => {
      const cycle = enums[d.idx];
      return { label: cycle.label, count: d.count, color: cycle.color };
    });
  }, [ data, enums ]);

  return (
    <article className="widget-main">
      <header className="widget-header">
        <Title variant="md" fixed>{title}</Title>
      </header>

      <main className="widget-section">
        <div className="widget-chart">
          <Bar title={title} parser={parser} data={graphData} />
        </div>

        <div className="widget-link">
          <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(path)}>
            View Reports
          </Button>
        </div>
      </main>
    </article>
  );
};

const BatteryHealth = ({ data }) => {
  return (
    <div className="widget-group widget-3">
      <BatteryTemperature data={data[MODULE_TYPES.BATTERY_TEMPERATURE]} enums={STATS_ENUMS[MODULE_TYPES.BATTERY_TEMPERATURE]} />
      <BatteryVoltage data={data[MODULE_TYPES.BATTERY_VOLTAGE]} enums={STATS_ENUMS[MODULE_TYPES.BATTERY_VOLTAGE]} />
      {data[MODULE_TYPES.CHARGING_CYCLE] ? <ShowPercentageGraph title={"Charging Cycle"} path={PATHS.CHARGE_CYCLE} xLabel={"Charging Cycles Completed %"} yLabel={"Vehicles"} data={data[MODULE_TYPES.CHARGING_CYCLE] || []} enums={STATS_ENUMS[MODULE_TYPES.CHARGING_CYCLE]} /> : null}
      {data[MODULE_TYPES.BATTERY_HEALTH] ? <ShowPercentageGraph title={"Battery Health"} path={PATHS.BATTERY_HEALTH} xLabel={"Current Battery Health %"} yLabel={"Vehicles"} data={data[MODULE_TYPES.BATTERY_HEALTH] || []} enums={STATS_ENUMS[MODULE_TYPES.BATTERY_HEALTH]} /> : null}
    </div>
  );
};

export default BatteryHealth;
